const config = {
    baseURL: "https://hsii-server.herokuapp.com/",
};

export default config;
